module.exports = __webpack_public_path__ + "img/Teleflex_Corporate Logo_RGB_Navy.2e5dc6a9.svg";